import { get } from 'lodash'

import { Colors, Services, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'

import { components, sizes } from '@/utils'

import info from '@/components/info'
import { urlShortenerSettingsDomainsStates } from '@/components/services/url-shortener-settings/domains/utils'
import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'
import tag from '@/components/tag'
import textOverflow from '@/components/text/overflow'

function renderWarning(h) {
  if (this.hasWarnings && this.showWarnings) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services['url-shortener-settings']}.${this.warningPath}`),
          color: Colors.warning
        }
      }
    )
  }
}
function renderDomain(h, data) {
  const state = get(data, '_item.state')

  return h(
    tag,
    {
      props: {
        label: this.getTranslate(`${getServiceNameViaPoint(Services['url-shortener-settings/domains'])}.states.${state}`),
        size: sizes.small,
        color: urlShortenerSettingsDomainsStates[state].color
      }
    }
  )
}
function renderItem(h, data) {
  const title = get(data, 'title')

  return h(
    'div',
    {
      class: `${Services['url-shortener']}-form-presetId__item`
    },
    [
      h(
        textOverflow,
        {
          props: {
            value: title ?? this.getTranslate('commons.no.data')
          }
        }
      ),

      renderDomain.call(this, h, data)
    ]
  )
}
function renderSelector(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.domainId`),
        items: this.selectItems,
        itemsDisabled: [ this.proxy ],
        required: this.required,
        clearable: !this.required,
        loading: this.loading,
        disabled: this.disabled,
        setRequiredOnMounted: this.setRequiredOnMounted,
        dense: true,
        autocomplete: true,
        details: false
      },
      scopedSlots: {
        item: ({ item }) => {
          return renderItem.call(this, h, item)
        }
      },
      on: {
        input: event => {
          this.proxy = event
          this.$emit('input', this.proxy)
        },
        search: event => {
          this.search = event
        }
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'grid grid-gap--8'
    },
    [
      renderSelector.call(this, h),
      renderWarning.call(this, h)
    ]
  )
}
